export default __webpack_public_path__ + "static/media/webinar_as_mentor.4bbb90ca.svg";